import { render, staticRenderFns } from "./PrivacyModalContent.vue?vue&type=template&id=33ac22a0&scoped=true&"
import script from "./PrivacyModalContent.vue?vue&type=script&lang=ts&"
export * from "./PrivacyModalContent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33ac22a0",
  null
  
)

export default component.exports